import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'styles/main.scss'
import {
  BrowserRouter as Router
} from "react-router-dom"
import { RecoilRoot } from 'recoil'

import "@fontsource/saira"
import ScrollToTop from 'components/ScrollToTop';

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </RecoilRoot>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
